import { computed, ref } from 'vue';
import type { USState, ValidationRules } from '@Shared';
import { useFormValidation, useFieldStatus } from '@Shared';
import type { MppPaymentFormData } from '@Use/useMppPayment';

export function useMppPaymentForm() {
    const name = ref('');
    const billingAddress = ref('');
    const city = ref('');
    const selectedState = ref<USState | null>(null);
    const zipCode = ref('');

    const formData = computed<MppPaymentFormData>(() => ({
        name: name.value.trim(),
        billingAddress: billingAddress.value.trim(),
        city: city.value.trim(),
        state: selectedState.value?.abbreviation?.trim().toUpperCase() ?? '',
        zipCode: zipCode.value.trim(),
    }));

    const validationRules = computed<ValidationRules>(() => ({
        name: [{ required: true, message: 'Name is required' }],
        billingAddress: [{ required: true, message: 'Billing address is required' }],
        city: [{ required: true, message: 'City is required' }],
        state: [{ required: true, message: 'State is required' }],
        zipCode: [
            { required: true, message: 'ZIP code is required' },
            { validateZipCode: true, message: 'ZIP code must be 5 digits' },
        ],
    }));

    const formValidation = useFormValidation(formData, validationRules);
    const { turnOnValidation, hasError, isValidationActive } = formValidation;
    const { getFieldStatus, getFieldMessage } = useFieldStatus(formValidation);

    return {
        name,
        billingAddress,
        city,
        selectedState,
        zipCode,
        formData,
        getFieldStatus,
        getFieldMessage,
        turnOnValidation,
        hasError,
        isValidationActive,
    };
}
